import { API } from "../../../api/constants"
import { CostCenterType, Employee } from "../types/Types"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"

export const getEmployeeNamesOnly = (search?: string) =>
    authenticatedAxiosInstance.get(API + `/employee/paginate/names-only` + (search ? `?search=${search}` : "")).then((res) => res.data)

export const getEmployeeByIdData = (data: string, minimal?: string) => authenticatedAxiosInstance.get(API + `/employee/get/${data}` + (minimal ? `?minimal=${minimal}` : "")).then((res) => res.data)

export const updateEmployee = (data: { id: string; body: Employee }) =>
    authenticatedAxiosInstance.put(API + "/employee/update/" + data.id, data.body).then((res) => res.data)

export const updateEmployeeKcGroup = (data: { kcid: string; gid: string }) =>
    authenticatedAxiosInstance.put(API + `/kc/user/${data.kcid}/update-rbac-role/${data.gid}`).then((res) => res.data)

// add Doc to Employee
export const postNewDocToEmployee = (data: { id: string; data: any }) =>
    authenticatedAxiosInstance
        .patch(API + "/employee/doc/array/" + data.id, data.data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((res) => res.data)

// delete Doc from single Employee
export const deleteDocFromEmployee = (data: { id: string; file: string }) =>
    authenticatedAxiosInstance.patch(API + "/employee/doc/delete/" + data.id, { file: data.file }).then((res) => res.data)

// Einladung: Link per Mail (14 Tage gültig), mit dem der Mitarbeiter sein Passwort selbst festlegt (Pfad unverändert, HM-002)
export const sendInviteToEmployee = (kcid: string) => authenticatedAxiosInstance.put(API + "/kc/user/" + kcid + "/sendPasswordResetEmail").then((res) => res.data)

// Admin setzt ein Passwort; der Mitarbeiter bekommt es per Mail, alle seine Sitzungen enden (HM-002)
export const setEmployeePassword = (data: { kcid: string; newPassword: string }) =>
    authenticatedAxiosInstance.put(API + "/kc/user/" + data.kcid + "/password", { newPassword: data.newPassword }).then((res) => res.data)

// KC USER WORK
export const getUserGroupsFromKC = () => authenticatedAxiosInstance.get(API + "/kc/groups").then((res) => res.data)

// get all cost center
export const getCostCenterData = () => authenticatedAxiosInstance.get(API + `/cost-centers`).then((res) => res.data)

// add cost center
export const addCostCenterData = (data: CostCenterType) => authenticatedAxiosInstance.post(API + `/cost-center`, data).then((res) => res.data)

// delete cost center
export const deleteCostCenterData = (id: string) => authenticatedAxiosInstance.delete(API + `/cost-center/` + id).then((res) => res.data)

// update costcenter of employee
export const updateCostCenterData = (data: { data: any; id: string }) =>
    authenticatedAxiosInstance.put(API + `/cost-center/` + data.id, data.data).then((res) => res.data)

// add driverslicence entry
export const addDriversLicenceEntry = (data: { id: string; note?: string; image: FormData }) =>
    authenticatedAxiosInstance
        .post(API + `/employee/${data.id}/driverslicence?note=${data.note}`, data.image, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((res) => res.data)

export const getTimeTrackingReportByEmployee = (id: string, startDate: Date, endDate: Date) =>
    authenticatedAxiosInstance.get(API + `/timetracking/${id}`, { params: { intervalStart: startDate, intervalEnd: endDate ?? undefined } }).then((res) => res.data)
